import { z } from 'zod'

import { auditShape } from '@/shared/details'

import { classApi } from '../../class-form/class'

/** The API's notes on a class: GET lists them, POST adds one. */
export function classNotesApi(classId: string): string {
  return `${classApi(classId)}/notes`
}

/** The API's note: GET reads it, PUT changes it, DELETE removes it. */
export function classNoteApi(classId: string, id: string): string {
  return `${classNotesApi(classId)}/${encodeURIComponent(id)}`
}

/** What the Notes tab needs: read to see notes, write to add and change them, delete to remove them. */
export const readClassNotesPermission = 'classes.class-notes.read'
export const writeClassNotesPermission = 'classes.class-notes.write'
export const deleteClassNotesPermission = 'classes.class-notes.delete'

/** The longest title and text, as the API takes them. */
export const titleLength = 200
export const textLength = 10_000

const noteSchema = z
  .object({
    id: z.string(),
    classId: z.string(),
    title: z.string(),
    text: z.string().nullish(),
    isImportant: z.boolean(),
  })
  .extend(auditShape)

/** A note on a class, as the Notes tab shows it. */
export type ClassNote = z.infer<typeof noteSchema>

export function parseClassNote(item: unknown): ClassNote {
  return noteSchema.parse(item)
}
